var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22417_21031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 23.3669C115.342 11.7788 90.5881 -2.84242 79 -3.49992C58.2516 -4.677 37.9792 0.710321 17.2331 1.8874C5.64509 2.54492 -3.58883 11.7788 -4.24747 23.3669C-5.42456 44.1153 -8.17651 61.3885 -6.99943 82.1369C-6.34075 93.725 35.9125 114.479 47.5006 115.137C68.3058 116.317 61.1962 116.317 82 115.137C93.5881 114.479 110.843 100.239 111.501 88.651C112.678 67.9026 117.177 44.1153 116 23.3669Z",
    fill: "url(#paint0_linear_22417_21031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4993 57.0885C62.0251 57.0885 66.5046 52.6091 66.5046 47.0833C66.5046 41.5576 62.0251 37.0781 56.4993 37.0781C50.9736 37.0781 46.4941 41.5576 46.4941 47.0833C46.4941 52.6091 50.9736 57.0885 56.4993 57.0885Z",
    fill: "url(#paint1_linear_22417_21031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4997 24.1304C38.6552 24.1304 24.1299 38.6555 24.1299 56.5002C24.1299 74.3447 38.6552 88.87 56.4997 88.87C60.0074 88.87 63.3739 88.305 66.5285 87.2691C64.3155 84.703 62.9736 81.3366 62.9736 77.6877C62.9736 73.1676 64.9982 69.142 68.2 66.4347C65.5162 62.8799 61.2316 60.62 56.4997 60.62C49.1076 60.62 42.8455 66.1286 41.9038 73.4502C41.7861 74.4153 40.8916 75.0746 39.9264 74.9803C38.9611 74.8391 38.2784 73.968 38.3961 73.0029C39.2437 66.4347 43.5753 61.0437 49.3666 58.5718C45.5293 56.1706 42.9632 51.9331 42.9632 47.0835C42.9632 39.6207 49.037 33.547 56.4997 33.547C63.9625 33.547 70.0361 39.6207 70.0361 47.0835C70.0361 51.9331 67.4702 56.1706 63.6329 58.5718C66.6226 59.843 69.2358 61.9147 71.1662 64.5042C73.1201 63.5155 75.3566 62.9741 77.6872 62.9741C81.3361 62.9741 84.7027 64.316 87.2687 66.5289C88.3045 63.3743 88.8695 60.0079 88.8695 56.5002C88.8695 38.6555 74.3443 24.1304 56.4997 24.1304Z",
    fill: "url(#paint2_linear_22417_21031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6872 66.5054C71.5213 66.5054 66.5049 71.5218 66.5049 77.6877C66.5049 83.8536 71.5213 88.87 77.6872 88.87C83.8531 88.87 88.8695 83.8536 88.8695 77.6877C88.8695 71.5218 83.8531 66.5054 77.6872 66.5054ZM83.6439 78.936C82.9614 79.6185 81.8275 79.6164 81.1471 78.936L79.4528 77.2417V82.396C79.4528 83.3708 78.6619 84.1616 77.6872 84.1616C76.7124 84.1616 75.9215 83.3708 75.9215 82.396V77.2417L74.2272 78.936C73.5721 79.5911 72.4168 79.6223 71.7305 78.936C71.0408 78.2463 71.0408 77.129 71.7305 76.4393L76.4388 71.731C77.1133 71.0565 78.2622 71.0576 78.9355 71.731L83.6439 76.4393C84.3335 77.129 84.3336 78.2463 83.6439 78.936Z",
    fill: "url(#paint3_linear_22417_21031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22417_21031",
    x1: 56.5,
    y1: 3.15434,
    x2: 56.5,
    y2: 111.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFC8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22417_21031",
    x1: 56.4993,
    y1: 23.5911,
    x2: 56.4993,
    y2: 86.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8227FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22417_21031",
    x1: 56.4997,
    y1: 23.5913,
    x2: 56.4997,
    y2: 86.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8227FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22417_21031",
    x1: 77.6872,
    y1: 23.5913,
    x2: 77.6872,
    y2: 86.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8227FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22417_21031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    rx: 56.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateprofile);
export default __webpack_public_path__ + "static/media/updateprofile.f2f65c52862cf4ee0f1fcfa541f4c7f0.svg";
export { ForwardRef as ReactComponent };